// utils
function getOfferProduct(value, offer) {
  let finalOffer = offer ?? value?.defaultProduct;

  return value?.offers?.[finalOffer] || [];
}

function getPorpArrayOfOffers(value, propName) {
  let res = null;
  const offers = Object.values(value?.offers);

  if (offers) {
    for (let offer of offers) {
      const prop = offer?.[propName];

      if (prop) {
        if (!res) res = {};
        res[JSON.stringify(prop)] = prop;
      }
    }

    res = Object.values(res);
  }

  return res;
}

// normalizers
function normalizeDeviceColor(value, offer) {
  const defProduct = getOfferProduct(value, offer);
  return defProduct?.color || null;
}

function normalizeDeviceImageList(value, offer) {
  const defProduct = getOfferProduct(value, offer);

  return defProduct?.imgs || null;
}

function normalizeDeviceMainImage(value, offer) {
  const defProduct = getOfferProduct(value, offer);

  return { src: defProduct?.imgs[0] || null };
}

function normalizeDeviceStorage(value, offer) {
  const defProduct = getOfferProduct(value, offer);

  return defProduct?.storage || null;
}

function normalizeDeviceColorList(value, offer) {
  const defProduct = getOfferProduct(value, offer);

  return defProduct?.availableColors || [];
}

function normalizeDeviceStorageList(value, offer) {
  const defProduct = getOfferProduct(value, offer);

  return defProduct?.availableStorages || [];
}

function normalizeDevicePrice(value, clientType, offer) {
  const product = getOfferProduct(value);
  const price = product?.price?.[clientType] || null;

  return { price, currency: "€/mes" };
}

function normalizeDeviceTitle(value) {
  return { text: value?.name || null };
}

function normalizeDeviceAliasUrl(value) {
  const product = getOfferProduct(value);

  return product?.aliasUrl;
}

export function normalizeDeviceItem(value, clientType, offer) {
  let res = {};

  res.name = value?.name;

  res.filters = value?.filters || [];
  res.productOffering = value?.productOffering || null;

  // gets default
  res.title = normalizeDeviceTitle(value);
  res.color = normalizeDeviceColor(value);
  res.image = normalizeDeviceMainImage(value, offer);
  res.imageList = normalizeDeviceImageList(value, offer);
  res.storage = normalizeDeviceStorage(value, offer);
  res.price = normalizeDevicePrice(value, clientType, offer);
  res.aliasUrl = normalizeDeviceAliasUrl(value);

  return res;
}

function main(data, clientType) {
  let res = [];
  if (!data) return null;

  for (let [key, value] of Object.entries(data)) {
    const normalizedProps = normalizeDeviceItem(value, clientType);

    if (normalizedProps) res.push({ alias: key, ...normalizedProps });
  }

  return res;
}

export default main;
